import {
  ERROR_LOADING_UNREAD_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS_STATUS,
  RESET_UNREAD_NOTIFICATIONS,
  START_LOADING_UNREAD_NOTIFICATIONS,
  STOP_LOADING_UNREAD_NOTIFICATIONS,
} from "./action-types";
import initialState from "./initialState";

export const unreadNotificationsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case START_LOADING_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        stateIs: "Pending",
      };

    case ERROR_LOADING_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        stateIs: "Error",
      };

    case STOP_LOADING_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        stateIs: "Idle",
      };

    case GET_UNREAD_NOTIFICATIONS_STATUS:
      return {
        ...state,
        data: {
          data: action.payload.data ?? false
        },
        message: action.payload.message || "",
        stateIs: "Idle",
      };

    case RESET_UNREAD_NOTIFICATIONS:
      return initialState;

    default:
      return state;
  }
};